import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import { useNavigate, useLocation } from "react-router";

export default function StudentNavBar({ navItems }) {
  const navigator = useNavigate();
  const location = useLocation();
  const [items] = useState(navItems);

  return (
    <Container>
      <Img src="/Assets/Images/Flag.png" alt="img" />
      <List>
        {items.map((data) => {
          return (
            <ListItemContainer
              isActive={location.pathname === data.navigate}
            >
              <ListItem
                isActive={location.pathname === data.navigate}
                onClick={() => {
                  if (!(location.pathname === data.navigate)) {
                    navigator(data.navigate);
                  }
                }}
              >
                <Button className="Item">
                  <ImgIcon
                    src={
                      location.pathname === data.navigate
                        ? data.activeImg
                        : data.img
                    }
                    alt="img"
                  />
                </Button>
                <TextContainer>
                  <Text isActive={location.pathname === data.navigate}>
                    {data.text}
                  </Text>
                </TextContainer>
              </ListItem>
            </ListItemContainer>
          );
        })}
      </List>
    </Container>
  );
}

const Container = styled.div`
  height: 80%;
  display: inline-block;
  background-color: ${Theme.colorBackgroundBox};
  border-radius: ${Theme.borderRadius};
`;

const List = styled.ul`
  margin: 20% 0;
  padding: 0;
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
`;

const Button = styled.button`
  background-color: ${Theme.colorIconButton};
  width: 50px;
  height: 50px;
  border: none;
  border-radius: ${Theme.borderRadius};
  margin: 5px;
  transition: all 500ms ease;
`;

const ListItemContainer = styled.li`
  list-style-type: none;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    height: 40%;
    background-color: ${Theme.colorBluePrimary};
    width: ${(props) => (props.isActive ? "8px" : "0px")};
    right: 0;
    border-bottom-left-radius: ${Theme.borderRadius};
    border-top-left-radius: ${Theme.borderRadius};
  }
`;

const ListItem = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  box-sizing: border-box;
  font-weight: 400;
  transition: all 500ms ease;

  &:hover {
    .Item {
      background-color: ${(props) =>
        props.isActive ? null : Theme.colorBackgroundBoxHover};
      cursor: ${(props) => (props.isActive ? null : "pointer")};
    }
  }
`;

const Img = styled.img`
  width: 170px;
  height: 58px;
  margin: 30px 20px 0 20px;
`;

const ImgIcon = styled.img``;

const TextContainer = styled.div`
  width: 100%;
  height: 5px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Text = styled.p`
  font-size: ${Theme.fontNavSize};
  font-weight: ${Theme.fontNavWeight};
  color: ${(props) =>
    props.isActive ? Theme.colorBluePrimary : Theme.colorFontLabel};
  cursor: pointer;
`;
